export const SET_PRODUCT_TYPE = 'SET_PRODUCT_TYPE';
export const SET_PRODUCT_CATEGORY = 'SET_PRODUCT_CATEGORY';
export const SET_PRODUCT_BRAND = 'SET_PRODUCT_BRAND';
export const SET_PRODUCT_LIST = 'SET_PRODUCT_LIST';
